import { Checkbox, MenuItem, Stack, TextField, Typography, useTheme } from "@mui/material";
import { CaretDownIcon } from "@phosphor-icons/react/dist/csr/CaretDown";
const MultiSelect = ({
  options,
  handleChange,
  value,
  maxItemsSelected,
}: {
  options: string[];
  handleChange: (value: string[]) => void;
  value: string[];
  maxItemsSelected?: number;
}) => {
  const theme = useTheme();
  return (
    <TextField
      select
      size="large"
      fullWidth
      slotProps={{
        select: {
          multiple: true,
          onChange: (e) => handleChange(e.target.value as string[]),
          // Change this once we support phosphor icons
          IconComponent: CaretDownIcon,
          MenuProps: {
            slotProps: {
              paper: {
                style: {
                  borderRadius: "4px",
                  padding: "24px",
                  boxShadow: theme.mixins.shadowSurfaceLight10,
                  maxHeight: "300px",
                  overflowY: "auto",
                },
              },
            },
            sx: {
              "& .MuiList-root": {
                padding: 0,
                display: "flex",
                flexDirection: "column",
                gap: "12px",
              },
            },
          },
          renderValue: (selected) => {
            return (selected as string[]).join(", ");
          },
        },
      }}
      value={value}
    >
      {options.map((option) => (
        <MenuItem
          key={option}
          value={option}
          disabled={maxItemsSelected && value.length == maxItemsSelected ? value.indexOf(option) === -1 : false}
          sx={(scopedTheme) => ({
            "&.Mui-selected": {
              backgroundColor: scopedTheme.palette.surfaceDark10.main,
            },
            "&.MuiMenuItem-root": {
              padding: 0,
            },
          })}
        >
          <Stack spacing="8px" direction="row">
            <Checkbox color="primary" checked={value.indexOf(option) > -1} />
            <Typography sx={{ color: "text40.main" }} variant="body.medium.regular">
              {option}
            </Typography>
          </Stack>
        </MenuItem>
      ))}
    </TextField>
  );
};

export { MultiSelect };
